import { translate } from '../../i18n/translations';
import type { Language, Theme } from '../../platform/settings/settings';
import type { Difficulty } from '../../game/generator';
import type { SessionAction } from '../../game/session';
import type { SudokuGameModel } from '../../app/use-sudoku-game';
import { GameScreen } from '../game/GameScreen';
import { SettingsPanel } from '../settings/SettingsPanel';
import styles from './AppShell.module.css';

type AppShellProps = {
  language: Language;
  theme: Theme;
  onLanguageChange: (language: Language) => void;
  onThemeChange: (theme: Theme) => void;
  game: SudokuGameModel;
  elapsedMs: number;
  onGameAction: (action: SessionAction) => void;
  onNewGame: (difficulty: Difficulty) => void;
};

export function AppShell({
  language,
  theme,
  onLanguageChange,
  onThemeChange,
  game,
  elapsedMs,
  onGameAction,
  onNewGame,
}: AppShellProps) {
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div className={styles.brand}>
          <span className={styles.mark} aria-hidden="true">
            <span />
            <span />
            <span />
            <span />
          </span>
          <div>
            <h1>{translate(language, 'appName')}</h1>
            <p>{translate(language, 'tagline')}</p>
          </div>
        </div>

        <SettingsPanel
          language={language}
          theme={theme}
          onLanguageChange={onLanguageChange}
          onThemeChange={onThemeChange}
        />
      </header>

      <main className={styles.main}>
        <GameScreen
          language={language}
          model={game}
          elapsedMs={elapsedMs}
          onAction={onGameAction}
          onNewGame={onNewGame}
        />
      </main>
    </div>
  );
}
